import styled from 'styled-components';

import { MAX_WIDTH } from '../../../constants';
import { ColumnBlock, HorizontalCenterBlock, VerticalHorizontalCenterBlock } from '../../../styled';

export const SignatureMethodChangeWrapper = styled(VerticalHorizontalCenterBlock)`
  width: 100%;
`;

export const Wrapper = styled(HorizontalCenterBlock)`
  flex-direction: column;
  width: ${MAX_WIDTH};
`;

export const WrapperCodeEditor = styled.div`
  border-radius: 6px;
`;

export const Subtitle = styled.h2`
  ${(p) => p.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  text-align: center;
  font-weight: 400;
`;

export const ChangeKeySubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  :last-of-type {
    margin-bottom: 8px;
  }
`;

export const BlockWrapper = styled(ColumnBlock)`
  gap: 32px;
`;

export const TokenExtra = styled.p`
  margin-right: 40px;
`;

export const ModalContentBox = styled.div`
  margin-bottom: 24px;
`;

export const HeavyFont = styled.span`
  font-weight: 700;
`;
